import React, { useState } from 'react';
import AuthLayout from './auth-layout';
import { useNavigate, useParams } from 'react-router-dom';
import authService from 'services/auth.service';
import { toast } from 'react-toastify';
import { Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { ROUTE_KEYS } from 'utils/constants';
import { handleApiError } from 'utils/functions';

type CreateFormType = {
  password: string;
  confirm_password: string;
};
const CreatePassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [formData, setFormData] = useState({} as CreateFormType);
  const [formError, setFormError] = useState<Partial<CreateFormType>>({});

  const formIsValid = (): boolean => {
    setFormError({});
    if (formData.password === formData.confirm_password) return true;
    if (formData.password === '') setFormError({ ...formError, password: 'Password is required' });
    if (formData.confirm_password === '')
      setFormError({ ...formError, confirm_password: 'Confirm Password is required' });

    if (formData.password !== formData.confirm_password) {
      setFormError(() => ({
        confirm_password: 'Passswords dont match',
        password: 'Passwords dont match'
      }));
    }
    return false;
  };

  const updateFormData = (key: string, value: string) => {
    setFormData((p) => ({ ...p, [key]: value }));
  };

  const routeToLogin = () => {
    navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}`);
  };

  const handleConfirm = async () => {
    if (!formIsValid()) return;
    if (token === 'admin') {
      const user_id = localStorage.getItem('user_id');
      try {
        const response = await authService.createPassword({ password: formData.password, user_id });
        if (response?.status === 201) {
          toast(<ToastMessage type='success' message='Password created successfully' />);
          routeToLogin();
        } else {
          toast(<ToastMessage type='error' message='An error occured' />);
        }
      } catch (err) {
        handleApiError(err);
      }
    }
  };
  return (
    <div>
      <AuthLayout
        onConfirm={handleConfirm}
        title={'Create new password'}
        subtitle={`Enter your preferred new password and confirm`}>
        <div className='flex flex-col gap-7'>
          <Input
            design='bordered'
            placeholder='Password'
            label='Password'
            type='password'
            value={formData.password}
            error={formError.password}
            onChange={(e) => updateFormData('password', e.target.value)}
          />
          <Input
            design='bordered'
            placeholder='Confirm Password'
            label='Confirm Password'
            type='password'
            error={formError.confirm_password}
            value={formData.confirm_password}
            onChange={(e) => updateFormData('confirm_password', e.target.value)}
          />
        </div>
      </AuthLayout>
    </div>
  );
};

export default CreatePassword;
